import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type {
  MapTimelineLayer,
  TimelineLayerId,
} from 'features/mapping/mapping.constants';
import { useMapLayersState } from 'state/useMapLayersState';
import { TimelineLayerMenuListItem } from './TimelineLayerMenuListItem';
import { TIMELINE_LAYER_THUMBNAILS } from './TimelineLayerMenu.constants';

type TimelineLayerMenuListProps = {
  layers: MapTimelineLayer[];
  selectedLayerId: TimelineLayerId;
  onSelect: (layerId: TimelineLayerId) => void;
  isMobile?: boolean;
};

/** Presents a list of selectable timeline layers. */
export const TimelineLayerMenuList = ({
  layers,
  selectedLayerId,
  onSelect,
  isMobile = false,
}: TimelineLayerMenuListProps): JSX.Element => {
  const { t } = useTranslation();
  const { mapBaseLayer } = useMapLayersState();

  return (
    <Stack>
      {layers.map((layer) => (
        <TimelineLayerMenuListItem
          key={layer.id}
          title={t(layer.titleKey)}
          subtitle={t(layer.subtitleKey)}
          shortSubtitle={t(layer.shortSubtitleKey)}
          thumbnail={TIMELINE_LAYER_THUMBNAILS[layer.id][mapBaseLayer]}
          selected={layer.id === selectedLayerId}
          isMobile={isMobile}
          onClick={() => onSelect(layer.id)}
        />
      ))}
    </Stack>
  );
};
